"use client";

import NextImage, { type ImageProps as NextImageProps } from "next/image";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";

import { CategoryCard } from "@/composite/CategoryCards";
import type { CategoryCardsReference } from "@/types/references";
import { resolveImageProps } from "@/app/utilities/images";

import type { CategoryCardsBlockProps } from ".";

export interface CategoryCardsBlockClientProps extends CategoryCardsBlockProps {
	cardsContent?: CategoryCardsReference[];
}

/**
 * Solution Based Card block component
 */
export function CategoryCardsBlock(
	props: CategoryCardsBlockClientProps
): JSX.Element {
	return (
		<CategoryCard<NextImageProps, NextLinkProps>
			headerText={props.section_title.headline}
			cards={
				props.cardsContent?.length
					? props.cardsContent?.map((card) => ({
							/*
						view: {
							type: card?.consultant_card_only
						},
						*/
							title: card?.card_title,
							image: {
								component: NextImage,
								...resolveImageProps("1:1", card.image)
							},
							link: {
								component: NextLink,
								href: card.call_to_action.link.href
							}
						}))
					: []
			}
		/>
	);
}
